import { render, staticRenderFns } from "./MFAConfigurationModal.vue?vue&type=template&id=d771d2c0&scoped=true"
import script from "./MFAConfigurationModal.vue?vue&type=script&lang=js"
export * from "./MFAConfigurationModal.vue?vue&type=script&lang=js"
import style0 from "./MFAConfigurationModal.vue?vue&type=style&index=0&id=d771d2c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d771d2c0",
  null
  
)

export default component.exports